/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type PlanSettingsScheduleType from '@jira/spa-apps__advanced-roadmaps-plan-settings/src/PlanSettingsScheduling.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type { Props } from '@jira/portfolio-3__portfolio/src/app-simple-plans/view/settings/scheduling/types.tsx';

/**
 * Plan Settings - scheduling page
 */

export const LazyPlanSettingsScheduling: LazyComponent<
	({ store, ...props }: Props) => React.JSX.Element
> = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazyForPaint<typeof PlanSettingsScheduleType>(
		() =>
			markAsProductBundleReady(
				import(
					/* webpackChunkName: "async-plan-settings-scheduling", jiraSpaEntry: "async-plan-settings-scheduling" */ '@jira/spa-apps__advanced-roadmaps-plan-settings/src/PlanSettingsScheduling.tsx'
				),
			),
		{ ssr: false },
	);

const AsyncPlanSettingsScheduling = (): React.JSX.Element => (
	<LazyPage
		Page={LazyPlanSettingsScheduling}
		pageId="plan-settings-scheduling"
		shouldShowSpinner={false}
	/>
);

export default AsyncPlanSettingsScheduling;
